import React, { Children, useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import styled from 'styled-components';
import { useFeatureFlag } from '../../FeatureFlagProvider';
import Loader from '../../Theme/Loader';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

const Carousel = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  scrollbar-width: 0;
  &::-webkit-scrollbar {
    display: none;
  }
  ${SCREEN_SIZE.Below.Desktop} {
    ${(props) => (props.isLastIndex ? '' : 'margin-right: -1rem;')}
  }
`;

// transform: translateX(-${(props) => props.activeIndex * 33.33}%)
const Inner = styled.div`
  white-space: nowrap;
  transition: transform 0.5s;
  margin: 0;
  transform: translateX(-${(props) => (props.activeIndex - 2) * 50}%);
  ${SCREEN_SIZE.Below.Desktop} {
    transform: translateX(-${(props) => (props.activeIndex - 3) * 50}%);
  }
  @media screen and (max-width: 460px) {
    > div:nth-child(1) {
      margin-left: 0;
    }
  }
`;

const CarouselItems = styled.div`
  width: ${(props) => props.width};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* height: 200px; 
  // background-color: green;  */
  color: #fff;
  margin-right: 5px;
  border-radius: 8px;
  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
  }
  /* margin-top: 15px;  */
`;

const Indicators = styled.div`
  display: flex;
  justify-content: center;
`;

const ArrowLeft = styled.div`
  display: none;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  z-index: 2;
  left: -1rem;
  ${SCREEN_SIZE.From.Desktop} {
    display: ${(props) => (props.role === 2 ? 'none' : 'inherit')};
  }
`;
const ArrowRight = styled.div`
  display: none;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  z-index: 2;
  right: -1rem;
  left: unset;
  ${SCREEN_SIZE.From.Desktop} {
    display: inherit;
  }
`;

const StyledSlideArrow = styled.div`
  cursor: pointer;
  font-size: 2rem;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  border-radius: 50%;
  background-color: #ffffff;
  justify-content: center;
  opacity: 0.8;
  border: 1px solid #eaeaea;
  :hover {
    background: #e8f0fd !important;
    border: 1px solid #a3c2f5 !important;
  }
  :visited {
    background: #e8f0fd !important;
    border: 2px solid #2070ef !important;
  }
  :focus {
    background: #e8f0fd !important;
    border: 2px solid #2070ef !important;
  }
  ${(props) => (props.direction === 'left' ? `left: 1rem;` : `right: 1rem;`)};

  > i {
    border: solid #0d3578;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: ${(props) => (props.direction === 'left' ? 'rotate(135deg)' : 'rotate(-45deg)')};
  }
`;
export const CarouselItem = ({ children, width }) => {
  return <CarouselItems width={width}>{children}</CarouselItems>;
};

const Slider = ({ children, filteredImg, category, isLastIndex }) => {
  const { isReady } = useFeatureFlag();
  const [activeIndex, setActiveIndex] = useState(2);
  const [isDisable, setIsDisable] = useState(true);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 600);

  useEffect(() => {
    if (activeIndex >= 3) {
      return setIsDisable(false);
    }
    return setIsDisable(true);
  }, [activeIndex]);

  useEffect(() => {
    setActiveIndex(2);
  }, [category]);

  const updateIndex = (newIndex) => {
    let index = newIndex;
    const maxCount = isMobile ? filteredImg.length - 1 : filteredImg.length / 2;
    if (newIndex > maxCount) {
      index = 2;
    }
    setActiveIndex(index);
  };

  /* eslint-disable react-hooks/exhaustive-deps */

  // eslint-disable-next-line
  const handlers = useSwipeable({
    onSwipedLeft: () =>
      updateIndex(filteredImg.length === 3 ? filteredImg.length : activeIndex + 1),
    onSwipedRight: () => updateIndex(activeIndex - 1),
  });

  useEffect(() => {
    const updateWindowDimensions = () => {
      setIsMobile(window.innerWidth < 600);
      if (window.innerWidth < 600) {
        setActiveIndex(2);
      }
    };

    window.addEventListener('resize', updateWindowDimensions);

    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  if (!isReady) {
    return <Loader />;
  }

  return (
    <>
      <Carousel {...handlers} data-testid="slider-carousel" isLastIndex={isLastIndex}>
        <Inner {...handlers} activeIndex={activeIndex} data-testid="slider">
          {Children.map(children, (child) => {
            return React.cloneElement(child, {
              width: isMobile ? '37.2%' : '120px',
            });
          })}
        </Inner>
        <Indicators>
          {filteredImg && filteredImg.length > 3 && (
            <>
              <ArrowLeft className="testslider" role={activeIndex}>
                <StyledSlideArrow
                  data-testid="minusButton"
                  direction="left"
                  onClick={() => !isDisable && updateIndex(activeIndex - 1)}
                  glyph="&#9664;"
                >
                  <i />
                </StyledSlideArrow>
              </ArrowLeft>

              <ArrowRight className="testslide" role={activeIndex}>
                <StyledSlideArrow
                  data-testid="plusButton"
                  direction="right"
                  onClick={() => updateIndex(activeIndex + 1)}
                  glyph="&#9654;"
                >
                  <i />
                </StyledSlideArrow>
              </ArrowRight>
            </>
          )}
        </Indicators>
      </Carousel>
    </>
  );
};
export default Slider;
